var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ClickToJump", {
    attrs: {
      message: _vm.$t(
        "pc_biz_ote_click_to_survey" /* 好的,正在为您唤起创建调查页面 */
      ),
      "target-url": _vm.targetUrl,
      datas: _vm.datas,
    },
    on: { open: _vm.setLocalStorage },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }